import { FC, Key, useCallback } from "react";
import { useAuth, useUser, useWorkspace } from "@/hooks";
import { Avatar, Button, Division, Flex, Icon, Icons, Menu, MenuItemProps, Span } from "@ir/ui";

const userMenuClassName = "sidebar-content-userMenu";

const userMenuItems: MenuItemProps[] = [{ key: "logout", label: "Log Out", icon: <Icon size="small" name={Icons.Logout} /> }];

const SidebarUserMenu: FC<{
  menuOpenChange: (isOpen: boolean) => void;
}> = ({ menuOpenChange }) => {
  const { logout } = useAuth();
  const { user } = useUser();
  const { userRoleNames } = useWorkspace();

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      menuOpenChange(isOpen);
    },
    [menuOpenChange]
  );

  const handleSelect = useCallback((optionKey: Key) => {
    const handleLogout = async () => {
      await logout();
    }

    if (optionKey === "logout") {
      handleLogout();
    }
  }, [logout]);

  if (!user) {
    return null;
  }

  return (
    <Division className={userMenuClassName}>
      <Menu items={userMenuItems} placement="top start" onOpenChange={handleOpenChange} onSelect={handleSelect}>
        <Button variant="clear" color="primary" className="slide-navigation-item">
          <Avatar size="small" boxShadow name={user.fullName} src={user.avatar ?? ""} alt="avatar" aria-label="User Avatar" className="slide-navigation-icon"/>
          <Flex direction="column" className="slide-navigation-label">
            <Span className="sidebar-user-name font-bold text-md text-grey-600">{user.fullName}</Span>
            <Span className="sidebar-user-role text-xs text-grey-500">{userRoleNames.join(", ")}</Span>
          </Flex>
        </Button>
      </Menu>
    </Division>
  );
};
export default SidebarUserMenu;
